// 设备识别工具
// 用于在 H5 路由下进一步区分手机与 PAD，便于做响应式适配

// 缓存 PAD 判定结果：设备类型在运行期不会变化，
// 且 isPadDevice() 依赖 innerWidth/innerHeight，PAD 固定 viewport(540) 后会改变这两个值，
// 若每次调用都实时计算，会出现“PAD 判定来回抖动”的问题。
let padCache = null

/**
 * 判断当前设备是否为 PAD（iPad / 安卓平板 / 折叠屏展开态）
 * 注意：此方法不改变路由决策，仅用于样式标记和页面级响应式判断；结果在模块加载后缓存
 */
export function isPadDevice() {
  if (padCache !== null) return padCache
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false
  const ua = navigator.userAgent
  const isIPadUA = /iPad/i.test(ua)
  const isMacTouch = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1
  const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua)
  const minSize = Math.min(window.innerWidth, window.innerHeight)
  const isLargeTouch = minSize >= 600 && window.matchMedia && window.matchMedia('(pointer: coarse)').matches
  padCache = isIPadUA || isMacTouch || isAndroidTablet || isLargeTouch
  return padCache
}

/**
 * 判断是否为移动端 UserAgent（保持与 router/index.js 一致）
 */
export function isMobileUA() {
  if (typeof navigator === 'undefined') return false
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi|MicroMessenger|QQBrowser|UCBrowser|baidubrowser|MiuiBrowser|HuaweiBrowser|Quark/i.test(navigator.userAgent)
}

/**
 * 判断当前屏幕宽度是否小于手机/平板分界点
 */
export function isMobileScreen() {
  return typeof window !== 'undefined' && window.innerWidth < 768
}

/**
 * 更新 html 上的设备类，供全局 CSS 使用
 */
export function updateDeviceClasses() {
  if (typeof document === 'undefined') return
  const html = document.documentElement
  const pad = isPadDevice()
  const mobile = isMobileUA() || isMobileScreen()
  if (pad) {
    html.classList.add('is-pad')
    html.classList.remove('is-phone')
  } else if (mobile) {
    html.classList.add('is-phone')
    html.classList.remove('is-pad')
  } else {
    html.classList.remove('is-pad', 'is-phone')
  }
}
